module.exports = __webpack_public_path__ + "img/poster-hz.7f40d9cc.png";